/* ==========================================================================
   Cartridge Finder
   --------------------------------------------------------------------------
   Renders wherever the page contains

       <div id="mwf-cartridge-finder"></div>

   Shares assets/mwf-filter-finder.css - same .mwf-ff__* classes, so the two
   funnels stay visually identical and there is one stylesheet to maintain.

   WHY THIS IS SHAPED THE WAY IT IS
   A wrong cartridge is a return, so this funnel is built around physical fit
   rather than around what the customer wants removed. Fit is decided by the
   housing: length (10" or 20"), diameter (2.5" slimline or 4.5" big blue) and
   how many housings there are. Only once that is pinned does what the
   cartridge should DO change the answer.

   The catalogue rewards this: replacement packs are named for the system they
   fit ("Replacement Cartridge Pack for ULTRAPURE 10\" Twin Benchtop/Under Sink
   Water Filter with Fluoride"), so an identified system resolves to an exact
   pack rather than a guess.

   WHEN IT DOES NOT KNOW, IT SAYS SO
   Every step carries a "I'm not sure" option. That path does not guess - it
   routes to the right filtered collection and tells the customer how to
   identify what they have. A confident wrong answer is worse than an honest
   narrowing.
   ========================================================================== */
(function () {
  'use strict';

  var SHOP = 'https://mywaterfilter.com.au';
  function P(h) { return SHOP + '/products/' + h; }
  function C(h) { return SHOP + '/collections/' + h; }

  var I = {
    house:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 13 16 4l12 9"/><path d="M7 12v14h18V12"/><path d="M13 26v-8h6v8"/></svg>',
    sink:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h26"/><path d="M5 12v16h22V12"/><path d="M12 18h8v8h-8z"/><path d="M16 4v8"/><path d="M12 4h8"/></svg>',
    urn:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4h14v9a7 7 0 0 1-7 7 7 7 0 0 1-7-7z"/><path d="M11 20v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6"/><path d="M23 24h4"/></svg>',
    shower:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4v10"/><path d="M6 9h10a6 6 0 0 1 6 6"/><path d="M16 18h12"/><path d="M18 23v3M22 23v4M26 23v3"/></svg>',
    ro:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="6" width="20" height="20" rx="3"/><path d="M11 16h10"/><path d="m17 12 4 4-4 4"/></svg>',
    inline:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 16h6"/><path d="M23 16h6"/><rect x="9" y="11" width="14" height="10" rx="3"/></svg>',
    cart:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="11" y="4" width="10" height="24" rx="2"/><path d="M14 4V2h4v2"/><path d="M14 28v2h4v-2"/></svg>',
    stack:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="6" width="7" height="20" rx="2"/><rect x="13" y="6" width="7" height="20" rx="2"/><rect x="22" y="6" width="7" height="20" rx="2"/></svg>',
    help:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="16" r="12"/><path d="M12.5 12.5a3.6 3.6 0 0 1 6.9 1.2c0 2.4-3.4 3-3.4 5"/><path d="M16 23h.01"/></svg>',
    check:'<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m3 8.5 3.2 3.2L13 5"/></svg>',
    tick:'<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="8"/><path d="m6.5 10.2 2.3 2.3L13.5 8"/></svg>',
    warn:'<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2.8 18.2 17H1.8z"/><path d="M10 8v4"/><path d="M10 14.6h.01"/></svg>'
  };

  /* ---------------------------------------------------------- step 1 --- */
  var SYSTEMS = [
    { id:'wholehouse', icon:I.house,  t:'Whole house',        d:'Big housings on the main line, usually outside or in the garage' },
    { id:'kitchen',    icon:I.sink,   t:'Under sink or benchtop', d:'Slimline housings at the kitchen tap' },
    { id:'gravity',    icon:I.urn,    t:'Gravity urn',        d:'Free-standing, uses candles rather than housings' },
    { id:'shower',     icon:I.shower, t:'Shower or bath',     d:'Cartridge inside the shower head or wall unit' },
    { id:'ro',         icon:I.ro,     t:'Reverse osmosis',    d:'Has a membrane and a separate drinking tap' },
    { id:'inline',     icon:I.inline, t:'Inline or fridge',   d:'A sealed tube in the water line, push-fit both ends' }
  ];

  /* ------------------- step 2, branch specific: WHICH SYSTEM ------------ */
  var UNSURE = { id:'unsure', icon:I.help, t:"I'm not sure", d:'Show me how to work out what I have' };

  var WH_HOUSING = [
    { id:'20x45-3', icon:I.stack, t:'20" x 4.5" - three housings', d:'Three fat blue canisters in a row' },
    { id:'20x45-2', icon:I.stack, t:'20" x 4.5" - two housings',   d:'Two fat blue canisters' },
    { id:'20x45-1', icon:I.cart,  t:'20" x 4.5" - one housing',    d:'A single fat blue canister' },
    { id:'10x45-3', icon:I.stack, t:'10" x 4.5" - three housings', d:'Three short fat canisters' },
    { id:'10x45-2', icon:I.stack, t:'10" x 4.5" - two housings',   d:'Two short fat canisters' },
    { id:'10x45-1', icon:I.cart,  t:'10" x 4.5" - one housing',    d:'A single short fat canister' },
    UNSURE
  ];

  var KITCHEN_SYS = [
    { id:'up-3',  icon:I.stack, t:'ULTRAPURE triple', d:'Three slimline housings, MWF branded' },
    { id:'up-2',  icon:I.stack, t:'ULTRAPURE twin',   d:'Two slimline housings, MWF branded' },
    { id:'dou-3', icon:I.stack, t:'Doulton triple',   d:'Three housings, ceramic Ultracarb candle inside' },
    { id:'dou-2', icon:I.stack, t:'Doulton twin',     d:'Two housings, ceramic Ultracarb candle inside' },
    { id:'other', icon:I.cart,  t:'Another brand',    d:'Aquasana, HiFlow, UltraStream, Omnipure and others' },
    UNSURE
  ];

  var GRAVITY_SYS = [
    { id:'filteroo', icon:I.urn,  t:'Filteroo',          d:'Joey, Superoo, Blue or the stainless urn' },
    { id:'berkefeld',icon:I.urn,  t:'British Berkefeld', d:'Ceramic candles, 5.75" or 7"' },
    { id:'berkey',   icon:I.urn,  t:'Berkey',            d:'Black Berkey elements and PF-2 / PF-4' },
    { id:'other',    icon:I.cart, t:'Another urn',       d:'Stefani, Phoenix, RAMA, Southern Cross Pottery' },
    UNSURE
  ];

  var SHOWER_SYS = [
    { id:'chrome',  icon:I.shower, t:'MWF Chrome shower filter', d:'Chrome or Deluxe Chrome shower filter' },
    { id:'aroma',   icon:I.shower, t:'Aroma Sense Q',            d:'Vitamin C shower filter with scent refills' },
    { id:'vitc',    icon:I.shower, t:'Vitamin C shower filter',  d:'The UBS Vitamin C shower unit' },
    { id:'sprite',  icon:I.shower, t:'Sprite',                   d:'Hand held, high output or bath ball' },
    { id:'aquasana',icon:I.shower, t:'Aquasana',                 d:'AQ-4100 or AQ-4105 shower filters' },
    UNSURE
  ];

  var RO_SYS = [
    { id:'ro4000',  icon:I.ro,   t:'MWF RO 4000',        d:'Benchtop reverse osmosis, sits by the tap' },
    { id:'hpf',     icon:I.ro,   t:'HPF under sink RO',  d:'4, 5 or 7 stage under the sink' },
    { id:'up-ro',   icon:I.ro,   t:'ULTRAPURE RO',       d:'Compact or Triple reverse osmosis' },
    { id:'other',   icon:I.cart, t:'Another RO system',  d:'Aquasana, Philips or a generic system' },
    UNSURE
  ];

  var INLINE_SYS = [
    { id:'fridge',  icon:I.inline, t:'Fridge or icemaker', d:'Feeds a fridge water and ice line' },
    { id:'hiflow',  icon:I.inline, t:'HiFlow under sink',  d:'Single inline cartridge, 1 or 5 micron' },
    { id:'generic', icon:I.inline, t:'Generic inline',     d:'Omnipure style, quarter inch push-fit ends' },
    UNSURE
  ];

  /* --------------------- step 3: WHAT SHOULD IT DO --------------------- */
  var NEEDS = {
    wholehouse: [
      { id:'sediment',   t:'Sediment and dirt',        d:'Grit, rust, cloudiness' },
      { id:'chlorine',   t:'Chlorine taste and smell', d:'Town water' },
      { id:'chloramine', t:'Chloramine',               d:'Needs a longer contact time than chlorine' },
      { id:'scale',      t:'Scale and hardness',       d:'White residue, appliance protection' },
      { id:'bacteria',   t:'Bacteria protection',      d:'Tank water, Aragon or Disruptor media' },
      { id:'same',       t:'Same as what is in there', d:'Just replace like for like' }
    ],
    kitchen: [
      { id:'sediment', t:'Sediment and dirt',        d:'Grit, rust, cloudiness' },
      { id:'chlorine', t:'Chlorine taste and smell', d:'The usual carbon stage' },
      { id:'fluoride', t:'Fluoride',                 d:'A dedicated fluoride stage' },
      { id:'alkaline', t:'Alkaline or minerals',     d:'Raises pH, adds minerals back' },
      { id:'ceramic',  t:'Ceramic candle',           d:'Doulton style, cleanable' },
      { id:'same',     t:'Same as what is in there', d:'Just replace like for like' }
    ],
    gravity: [
      { id:'carbon',   t:'Carbon block',             d:'The standard taste and clarity candle' },
      { id:'fluoride', t:'Fluoride removal',         d:'The extra fluoride cartridge' },
      { id:'ceramic',  t:'Ceramic',                  d:'Cleanable ceramic candle' },
      { id:'same',     t:'Same as what is in there', d:'Just replace like for like' }
    ],
    ro: [
      { id:'membrane', t:'The RO membrane',          d:'The heart of the system, lasts longest' },
      { id:'pre',      t:'Pre-filters',              d:'Sediment and carbon before the membrane' },
      { id:'post',     t:'Post filter or alkaline',  d:'Polishing or remineralising stage' },
      { id:'same',     t:'Everything, full service', d:'Replace the lot' }
    ]
  };

  /* ------------------------ step 4: PACK OR SINGLE --------------------- */
  var SCOPE = [
    { id:'pack',   icon:I.stack, t:'The full set',       d:'Every cartridge in the system, replaced together' },
    { id:'single', icon:I.cart,  t:'Just one cartridge', d:'I only need to replace one stage' }
  ];

  /* ------------------------------ answers ------------------------------ */
  /* Each answer is a named product where the catalogue has one that fits
     exactly, otherwise a filtered collection. `sure` marks how confident the
     match is, and the result screen says so plainly. */
  function A(title, handle, kind, sure, why, notes, pack) {
    return { title:title, handle:handle, kind:kind, sure:sure, why:why,
             notes:notes || [], pack:!!pack };
  }
  /* Marks an answer as a multi-cartridge pack, so step 4 can honour someone
     who only wants one stage instead of selling them the whole set. */
  function PACK(a) { a.pack = true; return a; }
  var COLLECTION = 'collection', PRODUCT = 'product';

  var WH_PACKS = {
    '20x45-3': PACK(A('MWF 20" x 4.5" Triple Whole House Water Filter Cartridge Pack',
      'mwf-20-x-4-5-triple-whole-house-cartridge-pack', PRODUCT, 'high',
      'A three-housing 20" x 4.5" system takes this pack.',
      ['All three cartridges, matched to the housings','Sized 20" x 4.5" big blue'])),
    '20x45-2': {
      bacteria: PACK(A('MWF 20" x 4.5" Twin Whole House Rain Water Tank Water Filter Cartridge Pack',
        'mwf-20-x-4-5-twin-whole-house-rain-cartridge-pack', PRODUCT, 'high',
        'Two 20" x 4.5" housings on tank water: this is the rain tank pack, with the bacteria stage.',
        ['Two cartridges, sized 20" x 4.5"','Includes the media that handles tank water'])),
      def: PACK(A('HPF 20" x 4.5" Twin Whole House Water Filter Cartridge Pack',
        'hpf-20-x-4-5-twin-whole-house-cartridge-pack', PRODUCT, 'high',
        'A two-housing 20" x 4.5" system on town water takes this twin pack.',
        ['Two cartridges, sized 20" x 4.5"','On tank water tell us so - that takes a different pack']))
    },
    '20x45-1': A('MWF 20" x 4.5" Single Whole House Water Filter Cartridge Selection',
      'mwf-20-x-4-5-single-whole-house-cartridge-selection', PRODUCT, 'medium',
      'One housing means one cartridge - pick the media on this page.',
      ['Sized 20" x 4.5" big blue','Choose sediment, carbon or Aragon on the product page']),
    '10x45-3': PACK(A('MWF 10" x 4.5" Triple Whole House Water Filter Cartridge Pack',
      'mwf-10-x-4-5-triple-whole-house-cartridge-pack', PRODUCT, 'high',
      'A three-housing 10" x 4.5" system takes this pack.',
      ['All three cartridges','Sized 10" x 4.5", the shorter big blue'])),
    '10x45-2': PACK(A('HPF 10" x 4.5" Twin Whole House Water Filter Cartridge Pack',
      'hpf-10-x-4-5-twin-whole-house-cartridge-pack', PRODUCT, 'medium',
      'A two-housing 10" x 4.5" system takes a twin pack.',
      ['Two cartridges, sized 10" x 4.5"','MWF and HPF housings take the same cartridge size'])),
    '10x45-1': A('HPF 10" x 4.5" Single Stage Whole House Water Filter Cartridge Pack',
      'hpf-10x4-5-single-stage-whole-house-cartridge-pack', PRODUCT, 'medium',
      'One short big blue housing.',
      ['Single cartridge, sized 10" x 4.5"'])
  };

  var KITCHEN_PACKS = {
    'up-2': {
      fluoride: PACK(A('Replacement Cartridge Pack for ULTRAPURE 10" Twin with Fluoride',
        'ultrapure-fluoride-cartridge-pack', PRODUCT, 'high',
        'The twin ULTRAPURE fluoride pack matches your system exactly.', [])),
      alkaline: PACK(A('Replacement Cartridge Pack for ULTRAPURE 10" Twin with Alkaline',
        'ultrapure-alkaline-cartridge-pack', PRODUCT, 'high',
        'The twin ULTRAPURE alkaline pack matches your system exactly.', [])),
      def: PACK(A('Replacement Cartridge Pack for ULTRAPURE 10" Twin with Sediment',
        'ultrapure-sediment-cartridge-pack', PRODUCT, 'high',
        'The standard twin ULTRAPURE pack: sediment then carbon.', []))
    },
    'up-3': {
      both: PACK(A('Replacement Cartridge Pack for ULTRAPURE 10" Triple, Fluoride & Alkaline',
        'ultrapure-fluoride-alkaline-cartridge-pack', PRODUCT, 'high',
        'The triple pack that covers both fluoride and alkaline.', [])),
      fluoride: PACK(A('Replacement Cartridge Pack for ULTRAPURE 10" Triple, Fluoride & Sediment',
        'ultrapure-fluoride-sediment-cartridge-pack', PRODUCT, 'high',
        'The triple pack with a dedicated fluoride stage.', [])),
      alkaline: PACK(A('Replacement Cartridge Pack for ULTRAPURE 10" Triple, Alkaline & Sediment',
        'ultrapure-alkaline-sediment-cartridge-pack', PRODUCT, 'high',
        'The triple pack with an alkaline stage.', [])),
      def: PACK(A('ULTRAPURE replacement cartridge packs',
        'cartridge-packs', COLLECTION, 'medium',
        'Several triple configurations exist, so pick the one matching your stages.', []))
    },
    'dou-2': {
      fluoride: PACK(A('Doulton Ultracarb 10" Twin with Fluoride Removal Cartridge Pack',
        'doulton-ultracarb-twin-with-fluoride-cp', PRODUCT, 'high',
        'Twin Doulton with the fluoride stage.', [])),
      alkaline: PACK(A('Doulton Ultracarb 10" Twin with Alkaline Cartridge Pack',
        'doulton-ultracarb-twin-with-alkaline-cp', PRODUCT, 'high',
        'Twin Doulton with the alkaline stage.', [])),
      def: PACK(A('Doulton Ultracarb 10" Twin with Sediment Cartridge Pack',
        'doulton-ultracarb-twin-sediment-cp', PRODUCT, 'high',
        'The standard twin Doulton pack.', []))
    },
    'dou-3': {
      both: PACK(A('Doulton Ultracarb 10" Triple with Fluoride Removal & Alkaline Pack',
        'doulton-ultracarb-triple-with-fluoride-alkaline-cp', PRODUCT, 'high',
        'Triple Doulton covering both fluoride and alkaline.', [])),
      fluoride: PACK(A('Doulton Ultracarb 10" Triple with Fluoride & Sediment Pack',
        'doulton-ultracarb-triple-fluoride-sediment-cp', PRODUCT, 'high',
        'Triple Doulton with the fluoride stage.', [])),
      alkaline: PACK(A('Doulton Ultracarb 10" Triple with Alkaline & Double Carbon Pack',
        'doulton-ultracarb-triple-with-alkaline-double-carbon-cp', PRODUCT, 'high',
        'Triple Doulton with alkaline and a second carbon stage.', [])),
      def: PACK(A('Doulton cartridge packs', 'cartridge-packs', COLLECTION, 'medium',
        'Several triple Doulton configurations exist; match yours by stage.', []))
    }
  };

  var GRAVITY_PACKS = {
    filteroo: {
      fluoride: A('Filteroo\u00ae MAX Fluoride Removal Gravity Cartridge',
        'filteroo-max-fluoride-removal-gravity-cartridge', PRODUCT, 'medium',
        'The extra fluoride cartridge that sits alongside the carbon block.',
        ['Also available as a twin pack','Fits the Joey, Superoo, Blue and stainless urns']),
      def: A('Filteroo gravity cartridges', 'benchtop-gravity-cartridges', COLLECTION, 'medium',
        'Filteroo candles come in 5.5" and 8" - the length depends on which urn you have.',
        ['Joey and Blue take the 5.5"','Superoo and the tall stainless urns take the 8"'])
    },
    berkefeld: A('British Berkefeld ceramic candles', 'ceramic-filter-cartridges', COLLECTION, 'medium',
      'Berkefeld candles come in 5.75" and 7", and the two are not interchangeable.',
      ['Measure the candle you are replacing','Ultra Fluoride and Ultra Sterasyl are different media']),
    berkey: A('Berkey elements', 'benchtop-gravity-cartridges', COLLECTION, 'medium',
      'Berkey uses Black Berkey elements plus optional PF-2 or PF-4 fluoride elements.',
      ['PF-2 suits Black Berkey elements','PF-4 suits the ceramic elements']),
    other: A('Gravity urn cartridges', 'benchtop-gravity-cartridges', COLLECTION, 'low',
      'Stefani, Phoenix, RAMA and Southern Cross candles are all urn specific.',
      ['Bring the old candle or a photo of it','Length and thread differ between brands'])
  };

  var SHOWER_PACKS = {
    chrome:  A('Replacement Cartridge for the Chrome Shower Filter',
      'chrome-shower-filter-cartridge', PRODUCT, 'high',
      'Fits the MWF Chrome shower filter.',
      ['The Deluxe Chrome takes its own cartridge - check which you have']),
    aroma:   A('Shower Filter Replacement Cartridge for Aroma Sense Q Vitamin C Shower Filter',
      'aroma-sense-vitamin-shower-filter-cartridge', PRODUCT, 'high',
      'Fits the Aroma Sense Q shower filter.',
      ['Sold in 3 and 6 refill packs','Choose your scent: lemon, rose, eucalyptus or scent free']),
    vitc:    A('3 x Vitamin C Shower Longer Lasting Filter Replacement Cartridges',
      'vitamin-shower-longer-cartridges', PRODUCT, 'medium',
      'The longer lasting Vitamin C refill.',
      ['A standard length refill is also available']),
    sprite:  A('Sprite shower cartridges', 'shower-filter-cartridges', COLLECTION, 'medium',
      'Sprite hand held, high output and bath ball units each take a different cartridge.',
      ['HHC-2 for hand held','HOC for high output','BBC for the bath ball']),
    aquasana:A('Aquasana shower cartridges', 'shower-filter-cartridges', COLLECTION, 'medium',
      'Aquasana chlorine and chloramine cartridges look alike but are not the same.',
      ['AQ-4125 for chlorine','AQ-4125C for chloramine'])
  };

  var RO_PACKS = {
    ro4000: {
      membrane: A('Filmtec 100GPD Reverse Osmosis Membrane for the Benchtop RO 4000',
        'filmtec-100gpd-ro-membrane-cartridge', PRODUCT, 'high',
        'The membrane for the RO 4000 benchtop system.',
        ['Replace roughly every 2 to 3 years']),
      pre: A('Sediment Inline Cartridge for Benchtop Reverse Osmosis System RO 4000',
        'sediment-inline-cartridge-ro4000', PRODUCT, 'high',
        'The pre-filter stage for the RO 4000.',
        ['Pre-filters protect the membrane, change them more often']),
      /* Only claim an exact match for the two stages we can name. Anything
         else - a post filter, a full service - is a narrowing, and the rail
         below carries the rest of the RO 4000 parts. */
      def: A('Sediment Inline Cartridge for Benchtop Reverse Osmosis System RO 4000',
        'sediment-inline-cartridge-ro4000', PRODUCT, 'medium',
        'This is the pre-filter for the RO 4000. Check which stage you are replacing - ' +
        'the membrane and the post filter are separate parts.',
        ['Pre-filters protect the membrane, change them more often',
         'The other RO 4000 parts are listed below'])
    },
    hpf:    A('Reverse osmosis membranes and cartridges', 'reverse-osmosis-membranes-cartridges', COLLECTION, 'medium',
      'HPF systems come in 4, 5 and 7 stage, and the stage count decides the set.',
      ['Count the housings under your sink','The membrane sits in the horizontal white tube']),
    'up-ro':A('Reverse osmosis membranes and cartridges', 'reverse-osmosis-membranes-cartridges', COLLECTION, 'medium',
      'ULTRAPURE RO comes as Compact and Triple, with different pre-filter sets.',
      ['Count the housings to tell them apart']),
    other:  A('Reverse osmosis membranes and cartridges', 'reverse-osmosis-membranes-cartridges', COLLECTION, 'low',
      'Aquasana and Philips RO use proprietary cartridges that only fit their own systems.',
      ['Find the model number on the unit','Generic membranes will not fit these'])
  };

  var INLINE_PACKS = {
    fridge:  A('Inline water filters', 'inline-water-filters', COLLECTION, 'medium',
      'Fridge and icemaker lines take a sealed inline cartridge with push-fit ends.',
      ['Check whether your fittings are 1/4" or 3/8"','Measure the length of the old one']),
    hiflow:  A('HiFlow 1 Micron Under Sink Inline Water Filter Replacement Cartridge',
      'hiflow-under-sink-inline-cartridge', PRODUCT, 'medium',
      'The HiFlow inline cartridge.',
      ['1 micron for normal water, 5 micron for harsh water - match what you have']),
    generic: A('Inline water filters', 'inline-water-filters', COLLECTION, 'medium',
      'Omnipure style inline cartridges are sized by length and fitting.',
      ['Measure the old cartridge end to end','Check the fitting size printed on the cap'])
  };

  var UNSURE_BY_SYSTEM = {
    wholehouse: A('Whole house cartridges', 'whole-house-filter-cartridges', COLLECTION, 'low',
      'Without the housing size we would only be guessing, and the wrong size will not fit.', []),
    kitchen: A('Under sink and benchtop cartridges', 'under-sink-filter-cartridges', COLLECTION, 'low',
      'Without knowing the system we would only be guessing.', []),
    gravity: A('Gravity urn cartridges', 'benchtop-gravity-cartridges', COLLECTION, 'low',
      'Urn candles are brand specific and lengths differ.', []),
    shower: A('Shower filter cartridges', 'shower-filter-cartridges', COLLECTION, 'low',
      'Shower cartridges are model specific.', []),
    ro: A('Reverse osmosis membranes and cartridges', 'reverse-osmosis-membranes-cartridges', COLLECTION, 'low',
      'RO sets depend on the stage count and the membrane rating.', []),
    inline: A('Inline water filters', 'inline-water-filters', COLLECTION, 'low',
      'Inline cartridges are sized by length and fitting.', [])
  };

  /* Step 4 answer 'single': the pack is the right identification, but the wrong
     line item. Send them to that system's individual cartridges instead. */
  var SINGLES = {
    wholehouse: { title:'Whole house cartridges, sold individually', handle:'whole-house-filter-cartridges' },
    kitchen:    { title:'Under sink and benchtop cartridges, sold individually', handle:'under-sink-filter-cartridges' },
    gravity:    { title:'Gravity urn cartridges, sold individually', handle:'benchtop-gravity-cartridges' },
    ro:         { title:'Reverse osmosis cartridges, sold individually', handle:'reverse-osmosis-membranes-cartridges' }
  };

  /* ------------------------------ the lookup ---------------------------
     Most cartridges carry a printed model code, and a code the customer
     reads off the sticker beats anything four questions can infer. So the
     funnel offers the shortcut first and falls back to the questions.

     It searches titles as well as codes, because a good half of our SKUs are
     internal warehouse codes that never appear on a cartridge, while the
     manufacturer's model usually does appear in the title. */
  var IDX = null;
  function norm(x)    { return String(x).toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim(); }
  function compact(x) { return String(x).toUpperCase().replace(/[^A-Z0-9]+/g, ''); }

  function buildIndex() {
    if (IDX) return IDX;
    var raw = window.MWF_CARTRIDGE_INDEX;
    if (!raw) return (IDX = []);
    IDX = raw.map(function (e) {
      var codes = e[2] ? e[2].split('|') : [];
      return {
        h: e[0], t: e[1], codes: codes,
        cc: codes.map(compact),
        nt: norm(e[1]),
        ct: compact(e[1])
      };
    });
    return IDX;
  }

  function searchIndex(q) {
    var list = buildIndex();
    var cq = compact(q);
    if (cq.length < 2) return [];
    /* Keep single digits: they carry the whole distinction in codes like
       PF-2 versus PF-4, where dropping the digit picks the wrong element. */
    var toks = norm(q).split(' ').filter(function (t) { return t.length > 1 || /[0-9]/.test(t); });
    var hits = [];
    for (var i = 0; i < list.length; i++) {
      var e = list[i], sc = 0, j;
      for (j = 0; j < e.cc.length; j++) {
        var c = e.cc[j];
        if (!c) continue;
        if (c === cq)                                sc = Math.max(sc, 1000);
        else if (c.indexOf(cq) === 0)                sc = Math.max(sc, 700);
        else if (cq.length >= 4 && c.indexOf(cq) >= 0) sc = Math.max(sc, 500);
        else if (cq.length >= 5 && cq.indexOf(c) >= 0) sc = Math.max(sc, 450);
      }
      /* A code typed without its separators still reads as one run of
         characters inside the title, e.g. AQ4035 inside "Aquasana AQ-4035". */
      if (!sc && cq.length >= 3 && e.ct.indexOf(cq) >= 0) sc = 300;
      if (!sc && toks.length) {
        var got = 0;
        for (j = 0; j < toks.length; j++) if (e.nt.indexOf(toks[j]) >= 0) got++;
        if (got === toks.length)      sc = 200;
        else if (toks.length > 2 && got === toks.length - 1) sc = 90;
      }
      /* Among equal matches prefer the shorter name: it is the plain
         cartridge rather than a bundle that merely mentions it. */
      if (sc) hits.push({ h: e.h, t: e.t, code: e.codes[0] || '', s: sc - e.t.length / 1000 });
    }
    hits.sort(function (a, b) { return b.s - a.s; });
    return hits.slice(0, 6);
  }

  /* ------------------------------- the rail ---------------------------
     When the answer is a range rather than one product, naming ten real
     cartridges beats handing over a browse page: the customer came here to
     be told what fits, and a 98-product collection is the thing they were
     already stuck in. Data lives in assets/mwf-cartridge-data.js. */
  var CDN = 'https://cdn.shopify.com/s/files/1/0455/8071/4143/';
  var RAIL_SHOWN = 10;

  function firstNeed(n, order) {
    for (var i = 0; i < order.length; i++) if (n[order[i]]) return order[i];
    return 'same';
  }
  /* Returns the buckets to try, most specific first. A specific one can
     legitimately be empty - we stock no 10" x 2.5" chloramine cartridge, and
     no carbon Berkey element - so each step widens rather than showing
     nothing. It never widens past what physically fits. */
  function railKeys(s) {
    var n = s.needs || {}, w = s.which;
    if (s.sys === 'wholehouse') {
      var size = String(w || '').split('-')[0];        /* 20x45-3 -> 20x45 */
      if (!size || w === 'unsure') return [];          /* size unknown: nothing fits for sure */
      var need = firstNeed(n, ['chloramine', 'bacteria', 'scale', 'sediment', 'chlorine']);
      return ['wh:' + size + ':' + need, 'wh:' + size + ':same'];
    }
    if (s.sys === 'kitchen') {
      var kn = firstNeed(n, ['fluoride', 'ceramic', 'alkaline', 'scale', 'sediment', 'chlorine']);
      return ['kt:' + kn, 'kt:same'];
    }
    if (s.sys === 'gravity') {
      var gn = firstNeed(n, ['fluoride', 'ceramic', 'carbon']);
      /* Urn candles are brand specific, so never widen past the named urn
         into another brand's candles - stop at that brand's full range. */
      if (w && w !== 'unsure') return ['gv:' + w + ':' + gn, 'gv:' + w + ':same'];
      return ['gv:same'];
    }
    if (s.sys === 'ro') {
      var rn = n.membrane ? 'membrane' : 'same';
      if (w && w !== 'unsure') return ['ro:' + w + ':' + rn, 'ro:' + w + ':same', 'ro:' + rn, 'ro:same'];
      return ['ro:' + rn, 'ro:same'];
    }
    if (s.sys === 'inline') return ['in:same'];
    return [];                                          /* shower is named exactly */
  }
  function railFor(s) {
    var data = window.MWF_CARTRIDGE_RAIL;
    if (!data) return null;
    var keys = railKeys(s);
    for (var i = 0; i < keys.length; i++) {
      var list = data[keys[i]];
      if (list && list.length) return list;
    }
    return null;
  }

  /* How to identify what you have - shown whenever confidence is not high. */
  var IDENTIFY = [
    'Read the model and micron printed on the old cartridge',
    'Measure it end to end - 10" and 20" are standard',
    'Measure the width - 2.5" slimline, 4.5" big blue'
  ];

  /* The result should show its working: what it matched on, in the customer's
     own answers. It also fills the space beside the heading, which the side
     card only occupies on a named-product result. */
  function labelOf(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i].t;
    return null;
  }
  function whichList(sys) {
    return sys === 'wholehouse' ? WH_HOUSING
         : sys === 'kitchen'    ? KITCHEN_SYS
         : sys === 'gravity'    ? GRAVITY_SYS
         : sys === 'shower'     ? SHOWER_SYS
         : sys === 'ro'         ? RO_SYS
         : sys === 'inline'     ? INLINE_SYS : [];
  }
  function answerSummary(s) {
    var out = [], v;
    if (s.found) {
      out.push(['You entered', s.q]);
      if (s.found.code) out.push(['Product code', s.found.code]);
      return out;
    }
    if ((v = labelOf(SYSTEMS, s.sys)))              out.push(['System', v]);
    if ((v = labelOf(whichList(s.sys), s.which)))   out.push([s.sys === 'wholehouse' ? 'Housings' : 'Model', v]);
    var list = NEEDS[s.sys], picked = [];
    if (list) for (var i = 0; i < list.length; i++) if (s.needs[list[i].id]) picked.push(list[i].t);
    if (picked.length)                              out.push(['Needs', picked.join(', ')]);
    if ((v = labelOf(SCOPE, s.scope)))              out.push(['Replacing', v]);
    return out;
  }

  function stepsFor(sys) {
    if (sys === 'shower')  return ['System', 'Which shower', 'Confirm'];
    if (sys === 'inline')  return ['System', 'Fitting', 'Confirm'];
    return ['System', 'Which one', 'What it does', 'Full set or one'];
  }

  function resolve(s) {
    /* A code read off the sticker beats anything the questions can infer,
       so a lookup hit short-circuits the whole funnel. */
    if (s.found) {
      return A(s.found.t, s.found.h, PRODUCT, 'high',
        'This is the cartridge matching the code you entered.',
        s.found.code ? ['Matched on ' + s.found.code] : []);
    }
    var a = resolveFit(s);
    /* Asking a question and then ignoring the answer is worse than not asking.
       If they only want one stage, the pack is the wrong thing to link to -
       but the pack still tells them which range fits, so we say so. */
    if (s.scope === 'single' && a.pack && SINGLES[s.sys]) {
      var one = SINGLES[s.sys];
      return A(one.title, one.handle, COLLECTION, 'medium',
        'Your system takes the ' + a.title + '. Since you only need one stage, ' +
        'here are those cartridges individually.',
        ['Match the size and media of the one you are replacing',
         'Replacing the whole set at once keeps the stages on the same schedule']);
    }
    return a;
  }

  function resolveFit(s) {
    if (s.which === 'unsure') return UNSURE_BY_SYSTEM[s.sys];
    var n = s.needs || {};
    if (s.sys === 'wholehouse') {
      var w = WH_PACKS[s.which];
      if (!w) return UNSURE_BY_SYSTEM.wholehouse;
      if (w.def) return (n.bacteria && w.bacteria) ? w.bacteria : w.def;
      return w;
    }
    if (s.sys === 'kitchen') {
      var set = KITCHEN_PACKS[s.which];
      if (!set) return A('Under sink and benchtop cartridges', 'under-sink-filter-cartridges', COLLECTION, 'low',
        'Other brands use their own cartridges, so start from the full range.',
        ['Aquasana, HiFlow, UltraStream and Omnipure all differ']);
      if (n.fluoride && n.alkaline && set.both) return set.both;
      if (n.fluoride && set.fluoride) return set.fluoride;
      if (n.alkaline && set.alkaline) return set.alkaline;
      return set.def;
    }
    if (s.sys === 'gravity') {
      var g = GRAVITY_PACKS[s.which];
      if (!g) return UNSURE_BY_SYSTEM.gravity;
      if (g.def) return (n.fluoride && g.fluoride) ? g.fluoride : g.def;
      return g;
    }
    if (s.sys === 'shower') return SHOWER_PACKS[s.which] || UNSURE_BY_SYSTEM.shower;
    if (s.sys === 'ro') {
      var r = RO_PACKS[s.which];
      if (!r) return UNSURE_BY_SYSTEM.ro;
      if (r.def) {
        if (n.membrane && r.membrane) return r.membrane;
        if (n.pre && r.pre) return r.pre;
        return r.def;
      }
      return r;
    }
    if (s.sys === 'inline') return INLINE_PACKS[s.which] || UNSURE_BY_SYSTEM.inline;
    return UNSURE_BY_SYSTEM[s.sys];
  }

  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  }
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  var SURE_LABEL = {
    high:   { t:'Exact match', cls:'is-high' },
    medium: { t:'Close match - check one thing', cls:'is-med' },
    low:    { t:'Narrowed down, not identified', cls:'is-low' }
  };

  /* ----------------------------------------------------------- render -- */
  function render(mount, state) {
    mount.innerHTML = '';
    var root = document.createElement('div');
    root.className = 'mwf-ff';

    root.insertAdjacentHTML('beforeend',
      '<div class="mwf-ff__head">' +
        '<div class="mwf-ff__head-t">Which replacement cartridge do I need?</div>' +
        '<div class="mwf-ff__head-r">' +
          '<div class="mwf-ff__head-s">Tell us what system you have and we will match the cartridge to it. ' +
          'If we cannot identify it exactly we will say so rather than guess.</div>' +
          '<div class="mwf-ff__head-m">' +
            '<span>' + I.tick + 'Matched on fit, not guesswork</span>' +
            '<span>' + I.tick + 'About 30 seconds</span>' +
            '<span>' + I.tick + 'No email required</span>' +
          '</div>' +
        '</div>' +
      '</div>');

    var steps = stepsFor(state.sys);
    var last = steps.length + 1;

    if (state.step <= steps.length) {
      var rail = document.createElement('div');
      rail.className = 'mwf-ff__rail';
      for (var i = 0; i < steps.length; i++) {
        var n = i + 1;
        var cls = 'mwf-ff__step' + (state.step === n ? ' is-now' : (state.step > n ? ' is-done' : ''));
        rail.insertAdjacentHTML('beforeend',
          '<div class="' + cls + '"><span class="mwf-ff__step-n">Step ' + n + '</span>' +
          '<span class="mwf-ff__step-l">' + steps[i] + '</span></div>');
      }
      root.appendChild(rail);
      root.insertAdjacentHTML('beforeend',
        '<div class="mwf-ff__rail-sm"><div class="mwf-ff__rail-sm-t">Step ' + state.step + ' of ' + steps.length +
        ' &middot; ' + steps[state.step - 1] + '</div><div class="mwf-ff__bar"><span style="width:' +
        (state.step / steps.length * 100) + '%"></span></div></div>');
    }

    var stage = document.createElement('div');
    stage.className = 'mwf-ff__stage';
    root.appendChild(stage);

    function go(patch) {
      for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) state[k] = patch[k];
      render(mount, state);
      root.scrollIntoView({ block: 'nearest' });
    }

    /* ------------------------------ result ------------------------------ */
    if (state.step >= last) {
      var a = resolve(state);
      var badge = SURE_LABEL[a.sure];
      var url = a.kind === PRODUCT ? P(a.handle) : C(a.handle);

      var main =
        '<span class="mwf-ff__badge ' + badge.cls + '">' + (a.sure === 'high' ? I.tick : I.warn) + ' ' + badge.t + '</span>' +
        '<div class="mwf-ff__res-h" role="heading" aria-level="3">' + esc(a.title) + '</div>' +
        '<div class="mwf-ff__why">' + a.why + '</div>';

      if (a.notes.length) {
        main += '<div class="mwf-ff__reasons" role="list">' + a.notes.map(function (x) {
          return '<div class="mwf-ff__reason" role="listitem">' + I.tick + '<span>' + x + '</span></div>';
        }).join('') + '</div>';
      }

      /* Anything short of an exact match gets the identification help. This is
         the point of the funnel: narrow honestly, never guess a fit. */
      if (a.sure !== 'high') {
        main += '<div class="mwf-ff__flag">' + I.warn +
          '<div><div class="mwf-ff__flag-t">The wrong length or width will not seal &mdash; worth checking</div>' +
          '<ul class="mwf-ff__flag-l" role="list">' +
          IDENTIFY.map(function (x) { return '<li role="listitem">' + x + '</li>'; }).join('') +
          '</ul></div></div>';
      }

      /* Show the rail when the answer is a range, not a single product: any
         collection result, or a request for one cartridge out of a pack. */
      var rail = (a.kind === COLLECTION || state.scope === 'single') ? railFor(state) : null;

      /* The side card names the recommended product and links to it. When the
         answer is a collection and the rail is showing, it would carry the
         same title as the heading and the same link as "See all" - three
         copies of one thing. Drop it and let the rail be the answer. */
      var showPick = !(a.kind === COLLECTION && rail);
      var side = '';
      if (showPick) {
        side +=
          '<div class="mwf-ff__pick">' +
            '<div class="mwf-ff__pick-hd">' + (a.kind === PRODUCT ? 'Your cartridge' : 'Where to look') + '</div>' +
            '<div class="mwf-ff__pick-bd">' +
              '<div class="mwf-ff__pick-nm">' + esc(a.title) + '</div>' +
              '<a class="mwf-ff__btn mwf-ff__btn--cta" data-go href="' + url + '">' +
                (a.kind === PRODUCT ? 'View this cartridge' : 'Browse these cartridges') + '</a>' +
            '</div>' +
          '</div>';
      }
      var sum = answerSummary(state);
      if (sum.length) {
        side += '<div class="mwf-ff__sum">' +
          '<div class="mwf-ff__sum-hd">Matched on your answers</div>' +
          '<dl class="mwf-ff__sum-l">' + sum.map(function (r) {
            return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>';
          }).join('') + '</dl>' +
        '</div>';
      }
      var html = '<div class="mwf-ff__res">' +
                 '<div class="mwf-ff__res-main">' + main + '</div>' +
                 (side ? '<div class="mwf-ff__res-side">' + side + '</div>' : '') +
                 '</div>';

      if (rail) {
        var shown = rail.slice(0, RAIL_SHOWN);
        var more  = rail.length - shown.length;
        html += '<div class="mwf-ff__rail-wrap">' +
          '<div class="mwf-ff__rail-hd">' +
            '<div class="mwf-ff__rail-t" role="heading" aria-level="4">Cartridges that fit</div>' +
            '<div class="mwf-ff__rail-n">' + shown.length +
              (more > 0 ? ' of ' + rail.length : '') + ' &middot; in stock first</div>' +
          '</div>' +
          '<div class="mwf-ff__cards" role="list" tabindex="0" aria-label="Cartridges that fit your system">' +
            shown.map(function (p) {
              var img = p.i ? CDN + p.i + '?width=240' : '';
              return '<a class="mwf-ff__card" role="listitem" data-card href="' + P(p.h) + '">' +
                '<span class="mwf-ff__card-img">' +
                  (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="240" height="240">' : I.cart) +
                '</span>' +
                '<span class="mwf-ff__card-t">' + esc(p.t) + '</span>' +
              '</a>';
            }).join('') +
          '</div>' +
          '<div class="mwf-ff__rail-ft">' +
            '<a class="mwf-ff__btn ' + (showPick ? 'mwf-ff__btn--alt' : 'mwf-ff__btn--cta') +
              '" data-all href="' + url + '">See all cartridges that fit &rarr;</a>' +
          '</div>' +
        '</div>';
      }

      html += '<div class="mwf-ff__foot">' +
        '<button type="button" class="mwf-ff__btn mwf-ff__btn--ghost" data-restart>&larr; Start again</button>' +
        '<a class="mwf-ff__btn mwf-ff__btn--alt" href="' + SHOP + '/pages/contact-us">Not sure? Ask us &rarr;</a>' +
        '</div>';

      stage.innerHTML = html;
      stage.querySelector('[data-restart]').addEventListener('click', function () {
        go({ step:1, sys:null, which:null, needs:{}, scope:null, q:'', found:null });
      });
      var go1 = stage.querySelector('[data-go]');
      if (go1) go1.addEventListener('click', function () {
        track('cartridge_finder_result_click', { target:a.handle, confidence:a.sure });
      });
      var cards = stage.querySelectorAll('[data-card]');
      for (var ci = 0; ci < cards.length; ci++) {
        (function (el, pos) {
          el.addEventListener('click', function () {
            track('cartridge_finder_card_click', {
              target: el.getAttribute('href').split('/').pop(), position: pos, system: state.sys
            });
          });
        })(cards[ci], ci + 1);
      }
      var all = stage.querySelector('[data-all]');
      if (all) all.addEventListener('click', function () {
        track('cartridge_finder_see_all', { target:a.handle, system:state.sys });
      });
      /* A CDN image that has been replaced upstream should leave a tidy card,
         not a broken-image glyph. */
      var imgs = stage.querySelectorAll('.mwf-ff__card-img img');
      for (var ii = 0; ii < imgs.length; ii++) {
        imgs[ii].addEventListener('error', function () { this.style.display = 'none'; });
      }
      track('cartridge_finder_result', { target:a.handle, confidence:a.sure, system:state.sys });
      mount.appendChild(root);
      return;
    }

    /* ---------------------------- questions ---------------------------- */
    var title, hint, list, key = null, chosen = null, cols = 3, multi = false;

    if (state.step === 1) {
      title = 'What kind of system is the cartridge going into?';
      hint  = 'Cartridges are matched on physical fit, so this is where we start.';
      list = SYSTEMS; key = 'sys'; chosen = state.sys;
    } else if (state.step === 2) {
      if (state.sys === 'wholehouse') {
        title = 'How big are the housings, and how many?';
        hint  = 'Measure one canister end to end. This is the single fact that decides fit.';
        list = WH_HOUSING; cols = 2;
      } else if (state.sys === 'kitchen') {
        title = 'Which system do you have?';
        hint  = 'Count the housings under the sink or on the bench, and check the branding.';
        list = KITCHEN_SYS; cols = 2;
      } else if (state.sys === 'gravity') {
        title = 'Which urn do you have?';
        hint  = 'Candles are brand specific and lengths differ, so the brand matters more than the media.';
        list = GRAVITY_SYS; cols = 2;
      } else if (state.sys === 'shower') {
        title = 'Which shower filter do you have?';
        hint  = 'Shower cartridges are model specific. If in doubt, the brand is usually on the housing.';
        list = SHOWER_SYS; cols = 2;
      } else if (state.sys === 'ro') {
        title = 'Which reverse osmosis system?';
        hint  = 'The stage count and the membrane rating decide the set.';
        list = RO_SYS; cols = 2;
      } else {
        title = 'What is the inline cartridge feeding?';
        hint  = 'Inline cartridges are sized by length and by the fitting on each end.';
        list = INLINE_SYS; cols = 2;
      }
      key = 'which'; chosen = state.which;
    } else if (state.step === 3 && NEEDS[state.sys]) {
      title = 'What do you need the cartridges to do?';
      hint  = 'Pick the stages your system runs. If you are replacing like for like, choose the last option.';
      list = NEEDS[state.sys]; multi = true; cols = 2;
    } else {
      title = 'Do you need the full set, or one cartridge?';
      hint  = 'Replacing everything at once keeps the stages on the same schedule.';
      list = SCOPE; key = 'scope'; chosen = state.scope; cols = 2;
    }

    stage.insertAdjacentHTML('beforeend',
      '<div class="mwf-ff__qhead"><div class="mwf-ff__q" role="heading" aria-level="3">' + title + '</div>' +
      '<div class="mwf-ff__hint">' + hint + '</div></div>');

    /* The shortcut goes above the questions, because someone holding the old
       cartridge can finish here in one step. It only appears if the data
       loaded, so a failed asset leaves the funnel intact rather than showing
       a search box that cannot search. */
    if (state.step === 1 && buildIndex().length) {
      stage.insertAdjacentHTML('beforeend',
        '<div class="mwf-ff__find">' +
          '<label class="mwf-ff__find-l" for="mwf-cf-q">' +
            'Know your cartridge? Type the model, brand or code printed on it' +
          '</label>' +
          '<div class="mwf-ff__find-row">' +
            '<input class="mwf-ff__find-i" id="mwf-cf-q" type="search" autocomplete="off" ' +
              'placeholder="e.g. AQ-4035, Ultracarb, PF-4" value="' + esc(state.q || '') + '" ' +
              'aria-describedby="mwf-cf-r">' +
          '</div>' +
          '<div class="mwf-ff__find-r" id="mwf-cf-r" role="listbox" aria-live="polite"></div>' +
        '</div>' +
        '<div class="mwf-ff__or"><span>or tell us what system you have</span></div>');

      var input = stage.querySelector('#mwf-cf-q');
      var res   = stage.querySelector('#mwf-cf-r');
      var timer = null;

      function draw() {
        var q = input.value.trim();
        state.q = q;
        if (q.length < 2) { res.innerHTML = ''; return; }
        var hits = searchIndex(q);
        if (!hits.length) {
          res.innerHTML = '<div class="mwf-ff__find-none">No match for &ldquo;' + esc(q) +
            '&rdquo;. Try the model printed on the cartridge, or answer the questions below.</div>';
          return;
        }
        res.innerHTML = hits.map(function (h, i) {
          return '<button type="button" class="mwf-ff__find-h" role="option" data-i="' + i + '">' +
            '<span class="mwf-ff__find-t">' + esc(h.t) + '</span>' +
            (h.code ? '<span class="mwf-ff__find-c">' + esc(h.code) + '</span>' : '') +
          '</button>';
        }).join('');
        var btns = res.querySelectorAll('[data-i]');
        for (var i = 0; i < btns.length; i++) {
          (function (b) {
            b.addEventListener('click', function () {
              var hit = hits[+b.dataset.i];
              track('cartridge_finder_lookup_hit', { query:q, target:hit.h });
              go({ found:hit, q:q, step:99 });
            });
          })(btns[i]);
        }
      }
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(draw, 120);
      });
      /* Enter takes the top match, which is what a barcode scanner sends. */
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        clearTimeout(timer);
        draw();
        var first = res.querySelector('[data-i]');
        if (first) first.click();
      });
      if (state.q) draw();
    }

    var wrap = document.createElement('div');
    wrap.className = 'mwf-ff__opts mwf-ff__opts--' + cols;
    list.forEach(function (o) {
      var on = multi ? !!state.needs[o.id] : chosen === o.id;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mwf-ff__opt';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.dataset.id = o.id;
      b.innerHTML = (multi ? '<span class="mwf-ff__box">' + I.check + '</span>'
                           : '<span class="mwf-ff__ico">' + (o.icon || I.cart) + '</span>') +
        '<span class="mwf-ff__txt"><span class="mwf-ff__t">' + o.t + '</span>' +
        '<span class="mwf-ff__d">' + o.d + '</span></span>';
      b.addEventListener('click', function () {
        if (multi) {
          if (state.needs[o.id]) delete state.needs[o.id]; else state.needs[o.id] = true;
          render(mount, state);
        } else {
          var patch = {};
          patch[key] = o.id;
          /* "I'm not sure" ends the funnel early rather than asking questions
             whose answers we could not use. */
          patch.step = (o.id === 'unsure' && key === 'which') ? last : state.step + 1;
          if (key === 'sys') { patch.which = null; patch.needs = {}; }
          track('cartridge_finder_step', { step:state.step, answer:o.id });
          go(patch);
        }
      });
      wrap.appendChild(b);
    });
    stage.appendChild(wrap);

    var foot = document.createElement('div');
    foot.className = 'mwf-ff__foot';
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'mwf-ff__btn mwf-ff__btn--ghost';
    back.textContent = '← Back';
    back.style.visibility = state.step === 1 ? 'hidden' : 'visible';
    back.addEventListener('click', function () { go({ step: state.step - 1 }); });
    foot.appendChild(back);

    var right = document.createElement('div');
    right.className = 'mwf-ff__foot-right';
    if (multi) {
      var picked = Object.keys(state.needs).length;
      var cnt = document.createElement('span');
      cnt.className = 'mwf-ff__count';
      cnt.textContent = picked === 0 ? 'Pick at least one' : picked + ' selected';
      right.appendChild(cnt);
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'mwf-ff__btn mwf-ff__btn--cta';
      next.textContent = 'Continue';
      next.disabled = picked === 0;
      next.addEventListener('click', function () { go({ step: state.step + 1 }); });
      right.appendChild(next);
    } else {
      var c2 = document.createElement('span');
      c2.className = 'mwf-ff__count';
      c2.textContent = 'Step ' + state.step + ' of ' + steps.length;
      right.appendChild(c2);
    }
    foot.appendChild(right);
    stage.appendChild(foot);
    mount.appendChild(root);
  }

  function boot() {
    var mounts = document.querySelectorAll('#mwf-cartridge-finder, [data-mwf-cartridge-finder]');
    for (var i = 0; i < mounts.length; i++) {
      if (mounts[i].getAttribute('data-cf-ready') === '1') continue;
      mounts[i].setAttribute('data-cf-ready', '1');
      render(mounts[i], { step:1, sys:null, which:null, needs:{}, scope:null, q:'', found:null });
      track('cartridge_finder_view', {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
